export * from "./MessageDialog";
export * from "./ThemeChooser";
export * from "./util";

export const ENV = {
  IS_LOCAL: process.env.REACT_APP_ENVIRONMENT_NAME === "local",
};
